import {
    JustpayFinalreconEndpointService
} from "@/views/loyalty/shared/endpoint_services/justpay-finalrecon-endpoint-service"

export class JustpayFinalreconService {
    constructor () {
        this.justpayFinalreconEndpointService = new JustpayFinalreconEndpointService()
    }

    async getAll () {
        const entities = await this.justpayFinalreconEndpointService.getList({ id: null, page: 1, limit: -1 })
        return entities || []
    }

    async getList (filter) {
        const entities = await this.justpayFinalreconEndpointService.getList(filter)
        return entities || []
    }
}
